import "../../node_modules/underscore/modules/index-default.js";
import "../../node_modules/underscore/modules/_setup.js";
import "../../node_modules/underscore/modules/isFunction.js";
import "../../node_modules/underscore/modules/_stringTagBug.js";
import "../../node_modules/underscore/modules/isArguments.js";
import "../../node_modules/underscore/modules/underscore.js";
import "../../node_modules/underscore/modules/isMap.js";
import "../../node_modules/underscore/modules/isWeakMap.js";
import "../../node_modules/underscore/modules/isSet.js";
import "../../node_modules/underscore/modules/toPath.js";
import "../../node_modules/underscore/modules/iteratee.js";
import "../../node_modules/underscore/modules/escape.js";
import "../../node_modules/underscore/modules/unescape.js";
import "../../node_modules/underscore/modules/templateSettings.js";
import "../../node_modules/underscore/modules/partial.js";
import "../../node_modules/underscore/modules/bind.js";
import "../../node_modules/underscore/modules/bindAll.js";
import "../../node_modules/underscore/modules/delay.js";
import "../../node_modules/underscore/modules/defer.js";
import "../../node_modules/underscore/modules/once.js";
import "../../node_modules/underscore/modules/invoke.js";
import "../../node_modules/underscore/modules/pick.js";
import "../../node_modules/underscore/modules/omit.js";
import "../../node_modules/underscore/modules/without.js";
import "../../node_modules/underscore/modules/union.js";
import "../../node_modules/underscore/modules/difference.js";
import "../../node_modules/underscore/modules/zip.js";
import "../../node_modules/underscore/modules/underscore-array-methods.js";
var e = 8,
  o = 9,
  s = 27,
  d = 13,
  r = 32,
  u = 38,
  m = 40,
  n = 37,
  l = 39,
  t = 46,
  i = function i(e) {
    return "number" == typeof e ? e : e.keyCode;
  },
  c = function c(e) {
    return s === i(e);
  },
  p = function p(e) {
    return r === i(e);
  };
export { e as BACKSPACE, t as DELETE, m as DOWN, d as ENTER, s as ESC, n as LEFT, l as RIGHT, r as SPACE, o as TAB, u as UP, i as getKeycode, c as isEscKey, p as isSpacebar };